export default "__VITE_ASSET__BPSEI9gs__"